export const hasError = state => state.auth.passwordChange.hasError
export const isPending = state => state.auth.passwordChange.isPending
export const user = state => state.auth.user
